import { takeEvery, put, call } from "redux-saga/effects";
import {
  FETCH_QUALIFICATIONS,
  CREATE_QUALIFICATION_REQUEST,
} from "./actionTypes";
import {
  fetchQualifications,
  fetchQualificationsSuccess,
  fetchQualificationsFailure,
  createQualificationSuccess,
  createQualificationFailure,
} from "./actions";
import { post } from "../../../helpers/api_helper";
import Swal from "sweetalert2";

// Fetch Qualifications
function* fetchQualificationsSaga({ payload: { unitId } }) {
  try {
    const formData = new FormData();
    formData.append("unit_id", unitId);

    const response = yield call(post, process.env.REACT_APP_GET_QUALIFICATIONS, formData);

    if (!response || response.status !== "success") {
      throw new Error(response?.message || "Failed to retrieve qualifications!");
    }

    yield put(fetchQualificationsSuccess(response));
  } catch (error) {
    console.error("Fetch Qualifications Saga Error:", error);
    yield put(fetchQualificationsFailure(error.message));
  }
}

// Create Qualification Saga
function* createQualificationSaga({ payload }) {
  try {
    const { formData } = payload;
    const response = yield call(post, process.env.REACT_APP_CREATE_QUALIFICATION, formData);

    if (response?.status === "success") {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response.message || "Qualification saved successfully!",
      });
      yield put(createQualificationSuccess(response));

      const unitId = formData.get("unit_id"); 
      if (unitId) {
        yield put(fetchQualifications(unitId));
      } else {
        console.log("unit_id is missing in formData, fetch not triggered");
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Something went wrong!",
      });
      yield put(createQualificationFailure("Unexpected response format"));
    }
  } catch (error) {
    console.error("Create Qualification Saga Error:", error);
    Swal.fire({
      icon: "error",
      title: "API Error",
      text: error.message || "An error occurred while saving the qualification",
    });
    yield put(createQualificationFailure(error.message));
  }
}

// Watcher Saga
function* qualificationSaga() {
  yield takeEvery(FETCH_QUALIFICATIONS, fetchQualificationsSaga);
  yield takeEvery(CREATE_QUALIFICATION_REQUEST, createQualificationSaga);
}

export default qualificationSaga;
